(function($, window, document, s, undefined){

  /**
  * Shows or hides the related region field to the field that is passed to it
  * by checking whether the value (country) of this field is Greece (GR).
  */
  var toggleRelatedRegionField = function toggleRelatedRegionField($el, selector) {
    if ($el.val() !== 'GR') {
      $el
        .closest('form')
        .find(selector)
          .closest('.form-group')
          .addClass('hidden')
          .find('.form-control')
            .val([]);;
    } else {
      $el
        .closest('form')
        .find(selector)
          .closest('.form-group')
          .removeClass('hidden');
    }
  };

// selector = '[id^="id_"][id$="_address-region"]'

  /**
  * Enables the appropriate behavior for the zone selection fields:
  *   - enables the postcode fields
  *   - hides or show the region fields depending on the country selected.
  *
  * This is basically a hack in order to counteract the behavior of
  * ZoneSelectorForm/SimpleZoneSelectorForm and its chain of ancestors.
  */
  var initZoneFieldsBehavior = function initZoneFieldsBehavior(
    countrySelector, regionSelector
  ) {
    // enable postcode fields
    $('[id^="id_"][id$="postcode"]').removeAttr('disabled');

    // do the initial check for the toggling of the related region field
    $(countrySelector).each(function(){
      toggleRelatedRegionField($(this), regionSelector);
    });

    // watch the field for changes in value and retoggle the region field
    $(countrySelector).on('change', function (e){
      toggleRelatedRegionField($(e.target), regionSelector);
    });
  };


  var checkForProfilePages = function checkForProfilePages() {
    if (['body-shipping-address-change', 'body-billing-address-change']
        .indexOf(s.bodyId) > -1) {
      initZoneFieldsBehavior('[id^="id_"][id$="_country"]',
                             '[id^="id_"][id$="_region"]');
    } else if (s.bodyId == 'body-cart-checkout') {
      initZoneFieldsBehavior('[id^="id_"][id$="_address-country"]',
                             '[id^="id_"][id$="_address-region"]');
    }
  };

  s.callOnReady(checkForProfilePages);

})(jQuery, this, this.document, window.s);
